'use client';

import { Container } from 'components/shared';
import { ReactNode, useContext, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../../shared/custom-image';
import { ImageModal } from './ImageModal';
import { OffersModalNewContext } from 'components/shared/OffersModal';
import styles from './PrimaryOffers.module.css';
// import { useWindowSize } from 'hooks/dom/useWindowSize';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export type OffersDataType = {
  image?: string[];
  imageType?: 'circle' | 'square';
  title: ReactNode;
  onClick?: () => void;
};

export const PrimaryOffersModalData = ({
  className,
  data,
}: {
  className?: string;
  data: OffersDataType[];
}) => {
  // const { width } = useWindowSize();
  const t = useTranslations('common');

  if (data.length < 1) return null;

  return (
    <div className={cx(styles.modalRoot, className)}>
        <h3>{t('primaryOffers.subheading.yourBestDeal')}</h3>

        <div className="content">
          {data.map((offer, index) => {
            return (
              <>
                <div className="offer" key={index}>
                  {/* <div className="image-container ">
                    <Image
                      src={offer.image ? offer.image[0] : ''}
                      alt=""
                      height="35"
                      width="35"
                    />
                  </div> */}
                  {offer.image && offer.image.length > 0 ? (
                    <div className="image-container">
                      {offer.image.map((img, index) => (
                        <Image
                          src={img}
                          alt="offer-icon"
                          height="40"
                          width="40"
                          key={index}
                        />
                      ))}
                    </div>
                  ) : null}
                  <p className="offer-text">{offer.title}</p>
                </div>
                {index !== data.length - 1 ? (
                  <div className="separator" />
                ) : null}
              </>
            );
          })}
        </div>
      </div>
    );
};
// Desktop
export const PrimaryOffers = ({
  className,
  data,
  $transparent,
  $backgroundColor,
  $dealsBackgroundColor,
}: {
  className?: string;
  data: OffersDataType[];
  $compact?: boolean;
  $transparent?: boolean;
  $backgroundColor?: string;
  $dealsBackgroundColor?: string;
}) => {
  if (data.length < 1) return null;

  return (
    <div
      className={cx(styles.primaryOffersRoot, className)}
      style={
        {
          background: $transparent
            ? 'transparent'
            : $backgroundColor || '#fff',
          ['--deals-bg']: $dealsBackgroundColor || '#fff',
        } as React.CSSProperties
      }
    >
      <Container>
          <div
            className="deals"
            // style={{
            //   justifyContent:
            //     data.length === 1
            //       ? 'center'
            //       : data.length === 2
            //       ? 'space-around'
            //       : 'space-between',
            // }}
          >
            {data.map((offer, index) => (
              <div className="deal" key={index}>
                {offer.image && offer.image.length > 0 ? (
                  <div className="image-container ">
                    {offer.image.map((img, index) => (
                      <Image
                        src={img}
                        alt=""
                        height="40"
                        width="40"
                        key={index}
                      />
                    ))}
                  </div>
                ) : null}
                <p className="deal-text">{offer.title}</p>
              </div>
            ))}
          </div>
        </Container>
      </div>
    );
};
// Mobile
export const PrimaryOffersTransitionTile = ({
  className,
  data,
  $compact,
  $transparent,
  backgroundColor,
}: {
  className?: string;
  data: OffersDataType[];
  $compact?: boolean;
  $transparent?: boolean;
  backgroundColor?: string;
  dealsBackgroundColor?: string;
}) => {
  const t = useTranslations('common');
    const [visibility, setVisibility] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setVisibility((prevVisibility) => {
          const nextVisibility =
            prevVisibility < data.length - 1 ? prevVisibility + 1 : 0;
          return nextVisibility;
        });
      }, 5000);
      return () => clearInterval(interval);
    }, [data]);

    const OfferModalNewClient = useContext(OffersModalNewContext);

    const handleSeeAll = () => {
      OfferModalNewClient.set(
        <ImageModal>
          <PrimaryOffersModalData data={data} />
        </ImageModal>,
      );
      OfferModalNewClient.show();
    };

    return (
      <div
        className={cx(styles.transitionRoot, className)}
        style={
          {
            marginBottom: $compact ? '0' : '1.6rem',
            background: $transparent ? 'transparent' : backgroundColor || '#eee',
          } as React.CSSProperties
        }
      >
        <Container
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            // gap: '10%',
          }}
        >
          <div className="deals">
            {data.map((offer, index) => {
              return (
                <div
                  className={`deal ${visibility === index ? 'visible' : ''}`}
                  key={index}
                >
                  {/* <div className="image-container ">
                    <Image
                      src={offer.image ? offer.image[0] : ''}
                      alt=""
                      height="24"
                      width="24"
                    />
                  </div> */}
                  {offer.image && offer.image.length > 0 ? (
                    <div className="image-container ">
                      {offer.image.map((img, index) => (
                        <Image
                          src={img}
                          alt=""
                          height="40"
                          width="40"
                          key={index}
                        />
                      ))}
                    </div>
                  ) : null}
                  <p className="deal-text">{offer.title}</p>
                </div>
              );
            })}
          </div>
          {data.length > 1 ? (
            <button className="see-all" onClick={handleSeeAll}>
              {t('primaryOffers.button.seeAll')}
            </button>
          ) : null}
        </Container>
      </div>
    );
};
